module.exports = "<div  class='jjog'>\r\n  <div #okrRef class='okrągły' (mousedown)='pozycja1($event)' (mousemove)='pozycja1($event)'\r\n  (click)=\"wyslijCos()\"   >\r\n  <div #okr1Ref class='okr2'></div>\r\n  <div [ngStyle]=\"{'visibility':isDivVisible ? 'visible' : 'hidden'}\"  [ngClass]=\"{'toggleColor': isDivVisible}\" >{{this.mouMov}}</div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/jog/jog.component.html
// module id = ./src/app/StartApp/welcome/start/simulator/jog/jog.component.html
// module chunks = main